export default class Gift {
  constructor (
    uuid,
    etherPrice,
    isReceived,
    senderAddress,
    receiverAddress,
    message,
    senderName,
    receiverName,
    isCancelled
  ) {
    this.uuid = uuid
    this.etherPrice = etherPrice
    this.isReceived = isReceived
    this.senderAddress = senderAddress
    this.receiverAddress = receiverAddress
    this.message = message
    this.senderName = senderName
    this.receiverName = receiverName
    this.isCancelled = isCancelled
  }

  static create (
    etherPrice,
    senderAddress,
    receiverAddress,
    message,
    senderName,
    receiverName
  ) {
    const uuidv4 = require('uuid/v4')
    return new Gift(
      uuidv4(),
      etherPrice,
      false,
      senderAddress,
      receiverAddress,
      message,
      senderName,
      receiverName,
      false)
  }
}



// WEBPACK FOOTER //
// ./src/models/Gift.js